import GameplayWorldWalls from "./Walls";
var GameplayWorld = /** @class */ (function () {
    function GameplayWorld() {
    }
    GameplayWorld.getInstance = function () {
        if (!this._instance) {
            this._instance = new GameplayWorld();
        }
        return this._instance;
    };
    GameplayWorld.prototype.load = function (scene) {
        this.scene = scene;
        GameplayWorldWalls.getInstance().load(this.scene).init();
    };
    return GameplayWorld;
}());
export default GameplayWorld;
